if (!customElements.get('smxb-desktop-menu')) {
  let nativeMenuReady;

  class SpiegelmaxDesktopMenu extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.desktop = matchMedia('(min-width: 1200px)');
      this.header = this.closest('smxb-header');
      this.desktop.addEventListener('change', () => this.updateViewport(), options);
      this.addEventListener('click', event => {
        if (event.target === this) {
          this.closeMenus();
          return;
        }
        const summary = event.target.closest('summary');
        const current = summary?.parentElement;
        if (current?.matches('.header__menu>ul>li>details')) this.closeMenus(current);
      }, { ...options, capture: true });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const current = event.target.closest('details[is=details-dropdown][open],details[is=details-mega][open]');
        if (!current) return;
        event.preventDefault();
        event.stopPropagation();
        this.closeBranch(current);
        current.querySelector(':scope>summary')?.focus({ preventScroll: true });
      }, options);
      this.header?.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closeMenus();
      }, { ...options, capture: true });
      this.header?.addEventListener('focusin', event => {
        if (!this.contains(event.target)) this.closeMenus();
      }, options);
      this.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => this.closeMenus(), options);
      this.updateViewport();
    }

    disconnectedCallback() {
      this.closeMenus();
      this.controller?.abort();
      this.controller = null;
    }

    closeMenus(except) {
      this.querySelectorAll('.header__menu>ul>li>details[open]').forEach(menu => {
        if (menu !== except) this.closeBranch(menu);
      });
    }

    closeBranch(menu) {
      menu.querySelectorAll('details[is=details-dropdown][open],details[is=details-mega][open]').forEach(child => {
        child.open = false;
      });
      menu.open = false;
    }

    updateViewport() {
      if (!this.desktop.matches) {
        this.closeMenus();
        return;
      }
      if (customElements.get('details-dropdown')) {
        this.setAttribute('data-enhanced', '');
        return;
      }
      if (!nativeMenuReady) {
        nativeMenuReady = new Promise(resolve => {
          const url = new URL(this.dataset.nativeScript, document.baseURI).href;
          let script = [...document.scripts].find(element => element.src === url);
          const existing = Boolean(script);
          script ||= document.createElement('script');
          script.addEventListener('load', resolve, { once: true });
          script.addEventListener('error', resolve, { once: true });
          if (!existing) {
            script.src = url;
            script.defer = true;
            document.head.appendChild(script);
          }
        });
      }
      nativeMenuReady.then(() => {
        if (!this.isConnected || !customElements.get('details-dropdown')) return;
        // Preserve a menu opened while the native menu script was still loading.
        this.querySelectorAll('.header__menu>ul>li>details[open]').forEach(menu => {
          if (!menu.querySelector(':scope>summary')?.hasAttribute('open') && typeof menu.transition === 'function') {
            menu.transition(true);
          }
        });
        this.setAttribute('data-enhanced', '');
      });
    }
  }

  customElements.define('smxb-desktop-menu', SpiegelmaxDesktopMenu);
}

